<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <v-dialog :fullscreen="isMobile" width="820" v-model="dialog" scrollable>
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title> THÊM CÔNG VIỆC MỚI </v-toolbar-title>
        <v-spacer />
        <v-btn icon dark>
          <v-icon @click="close">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form class="mb-2 mt-6" ref="form" lazy-validation>
          <v-text-field
            class="mt-4 mb-2 required"
            v-model="form.title"
            label="Tên công việc"
            :rules="[$rules.required]"
            required
            dense
            outlined
          />
          <v-row>
            <v-col cols="12">
              <AutocompleteExcludeTask
                :syncedValue.sync="form.receivers"
                item-text="name"
                clear-icon="mdi-close"
                outlined
                dense
                :rules="[$rules.required]"
                class="mb-2 required"
                deletable-chips
                label="Người nhận việc"
                hide-details
                :displaySubjectGroup="true"
                multiple
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <DateIOSPicker
                :date.sync="form.due_date"
                label="Hạn hoàn thành"
                dense
                outlined
                class="required"
                clearable
                :rules="[$rules.required, $rules.date, $rules.validFutureDate]"
              />
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="form.priority"
                :items="priorities"
                item-value="value"
                item-text="text"
                label="Mức ưu tiên"
                class="required"
                dense
                outlined
                clearable
              >
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-content>
                      <v-list-item-title :style="{ color: item.color }">
                        {{ item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ item }">
                  <span :style="{ color: item.color }">
                    {{ item.text }}
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <vue-editor
            dense
            class="my-2"
            v-model="form.description"
            outline
            :editorOptions="editorOptions"
            :editorToolbar="[
              [{ header: [1, 2, false] }],
              ['bold', 'italic', 'underline'],
              [{ color: [] }, { background: [] }],
              ['link', 'image', 'video'],
              [{ align: [] }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ indent: '-1' }, { indent: '+1' }],
              ['clean'],
            ]"
          />
          <div class="text-right text-caption mt-1">
            <span :class="{ 'red--text': descriptionLength > 500 }">
              {{ descriptionLength }} / 500 ký tự giới hạn
            </span>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none text-uppercase" outlined @click="close">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" @click="submit" :loading="loading">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AutocompleteExcludeTask from '@/components/basic/input/AutocompleteExcludeTask'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import { VueEditor } from 'vue2-editor'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    state: Boolean,
  },
  components: {
    VueEditor,
    DateIOSPicker,
    AutocompleteExcludeTask,
  },
  data() {
    return {
      dialog: false,
      isMobile: false,
      valid: true,
      form: {
        title: '',
        description: '',
        receivers: [],
        due_date: '',
        priority: null,
        hashtag: '',
        note: '',
      },
      loading: false,
      priorities: [
        { value: 0, text: 'Khẩn cấp', color: 'red' },
        { value: 1, text: 'Cao', color: 'orange' },
        { value: 2, text: 'Bình thường', color: '#c09000' },
        { value: 3, text: 'Thấp', color: 'blue' },
        { value: 4, text: 'Rất thấp', color: 'grey' },
      ],
      editorOptions: {
        placeholder: 'Nhập mô tả công việc (tối đa 500 ký tự)...',
      },
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    descriptionLength() {
      var text = (this.form.description && this.form.description.replace(/<[^>]*>/g, '')) || ''
      return text.trim().length
    },
    isDescriptionTooLong() {
      return this.descriptionLength > 500
    },
  },
  methods: {
    ...mapActions({
      findUsersExcludeRoles: 'tasknew/findUsersExcludeRoles',
    }),
    close() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async submit() {
      if (!this.$refs.form.validate()) return
      if (this.isDescriptionTooLong) {
        this.$alert.error('Mô tả công việc vượt quá 500 ký tự.')
        return
      }
      try {
        const receiversData = this.form.receivers.map(user => ({
          name: user.name || user.username || '',
          user_id: user._id,
          role_id: user.group_id || '',
          role_name: user.group || '',
        }))
        const payload = {
          title: this.form.title,
          description: this.form.description,
          due_date: this.form.due_date,
          priority: this.form.priority,
          hashtag: this.form.hashtag,
          note: this.form.note,
          receiversData,
          creatorData: {
            name: this.user.name,
            user_id: this.user.id,
            role_id: this.user.role.id,
            role_name: this.user.role.name,
          },
        }
        const res = await this.$store.dispatch('tasknew/createTaskNew', payload)
        if (res) {
          this.$emit('done')
          this.close()
          this.$alert.success('Tạo công việc thành công!')
        } else {
          this.$alert.error('Tạo công việc thất bại')
        }
      } catch (err) {
        this.$alert.error('Tạo công việc thất bại')
      } finally {
        this.loading = false
      }
    },
    onResize() {
      if (window.innerWidth < 600) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.onResize, { passive: true })
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>

<style scoped>
.v-data-footer {
  flex-wrap: nowrap;
}

.v-data-footer__icons-before {
  order: -1;
}
</style>
